import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import './reports.css';
import Header from '../common/Header';
import { COMMON, SYNC_SERVICE, REPORTS_SCREEN, ALL_ROUTES } from '../../global/Constants';
import DesktopFooter from '../common/DesktopFooter';
import ApiServices from '../../providers/ApiServices';
import Utilities from '../../global/Utilities';
import Select from 'react-select';
import Loader from '../common/loader/Loader';
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import { HeaderTypes } from '../../global/Enum';
import SyncServices from '../../providers/SyncServices';
import SyncLoader from '../common/loader/SyncLoader';
import AuthService from '../../providers/AuthService';

require('datatables.net');

class UserLocationReport extends Component {

    constructor(props) {
        super(props)
        this.datatable = null;

        this.state = {
            allRoleData: [
                {
                    value: 0,
                    label: "FDO"
                },
                {
                    value: 1,
                    label: "RM"
                },
                {
                    value: 2,
                    label: "TM"
                },
                {
                    value: 3,
                    label: "VP"
                }
            ],
            allEmployeeNameData: [],
            allStatesData: [],
            allDistrictsData: [],
            allTehsilsData: [],
            allVillagesData: [],
            selectedState: null,
            selectedRole: null,
            selectedDistrict: null,
            selectedTehsil: null,
            selectedVillage: null,
            selectedEmployeeName: [],
            isLoading: false,
        }
    }

    componentDidMount() {
        const session = AuthService.getSession();
        if (session) {
            this.getAllStates();
            this.getAllEmployee();
            this.initializeDataTable();
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    initializeDataTable() {

        this.$el = $(this.el);
        this.dataTable = this.$el.DataTable({
            columns: [
                { title: COMMON.EMPLOYEE_ROLE },
                { title: COMMON.EMPLOYEE_ID },
                { title: COMMON.EMPLOYEE_NAME },
                { title: COMMON.EMPLOYEE_PHONE },
                { title: COMMON.EMPLOYEE_REPORTING_MANAGER },
                { title: COMMON.STATE },
                { title: COMMON.DISTRICT },
                { title: COMMON.TEHSIL },
                { title: COMMON.VILLAGE },
            ]
        });

        var dataTableUserLocation = this.dataTable;

        $(document).ready(function () {

            $('#krishakReport thead tr').clone(true).appendTo('#krishakReport thead');
            $('#krishakReport thead tr:eq(1) th').each(function (i) {

                var title = $(this).text();
                $(this).html('<input type="text" placeholder="Search ' + title + '" />');

                $('input', this).on('keyup change', function () {
                    if (dataTableUserLocation.column(i).search() !== this.value) {
                        dataTableUserLocation
                            .column(i)
                            .search(this.value)
                            .draw();
                    }
                });
            });
        });
    }

    getUserLocationReport = () => {
        this.setState({ isLoading: true });
        const { selectedEmployeeName, selectedRole, selectedState, selectedTehsil, selectedVillage, selectedDistrict } = this.state;

        let selectedUserIds = [];
        if (selectedEmployeeName && selectedEmployeeName.length !== 0) {
            for (let i = 0; i < selectedEmployeeName.length; i++) {
                selectedUserIds.push(selectedEmployeeName[i].value)
            }
        } else {
            selectedUserIds = []
        }
        Utilities.LogPrint("selectedUserIds", selectedUserIds);

        var body = JSON.stringify({
            state_id: selectedState ? selectedState.value : 0,
            village_id: selectedVillage ? selectedVillage.value : 0,
            district_id: selectedDistrict ? selectedDistrict.value : 0,
            tehsil_id: selectedTehsil ? selectedTehsil.value : 0,
            user_id: selectedUserIds,

        });
        try {
            ApiServices.getUserLocationReport(body).then(response => {
                var status = response.success;
                this.setState({ isLoading: false });
                if (status) {
                    //Utilities.LogPrint("getUserLocationReportResponse", response);
                    let newArrayOfObj = response.data;
                    let tempMainArray = [];

                    if (selectedRole) {
                        let filterKrishakArray = [];
                        for (var i = 0; i < newArrayOfObj.length; i++) {
                            if (newArrayOfObj[i]["employee_role"] === selectedRole.label) {
                                filterKrishakArray.push(newArrayOfObj[i])
                            }
                        }
                        Utilities.LogPrint("newArrayOfObj", filterKrishakArray);
                        newArrayOfObj = filterKrishakArray
                    }

                    for (let i = 0; i < newArrayOfObj.length; i++) {
                        let tempArray = [];

                        tempArray.push(newArrayOfObj[i]["employee_role"]);
                        tempArray.push(newArrayOfObj[i]["employee_id"]);
                        tempArray.push(newArrayOfObj[i]["employee_name"]);
                        tempArray.push(newArrayOfObj[i]["employee_phone"]);
                        tempArray.push(newArrayOfObj[i]["employee_reporting_manager"]);
                        tempArray.push(newArrayOfObj[i]["state_name"] + "(" + newArrayOfObj[i]["state_id"] + ")");
                        tempArray.push(newArrayOfObj[i]["district_name"] + "(" + newArrayOfObj[i]["district_id"] + ")");
                        tempArray.push(newArrayOfObj[i]["tehsil_name"] + "(" + newArrayOfObj[i]["tehsil_id"] + ")");
                        tempArray.push(newArrayOfObj[i]["village_name"] + "(" + newArrayOfObj[i]["village_id"] + ")");
                        tempMainArray.push(tempArray);
                    }
                    this.dataTable.clear();
                    this.dataTable.rows.add(tempMainArray);
                    this.dataTable.draw();
                } else {
                    if (response.message === COMMON.TOKEN_EXPIRED) {
                        Utilities.tokenExpiredRedirectToLogin();
                    }
                }
            }).catch(error => {
                this.setState({ isLoading: false });
                Utilities.LogPrint("krishakReport", error);
            });
        } catch (error) {
            this.setState({ isLoading: false });
            Utilities.LogPrint("krishakReport", error);
        }
    }

    getAllEmployee = () => {
        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_EMPLOYEE, SYNC_SERVICE.MASTER_TABLE).then(data => {
            Utilities.LogPrint("allEmployeeData", data);
            if (data && data !== undefined && data.length > 0) {
                this.setState({
                    allEmployeeNameData: data.map(({ user_id: value, name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });
    }

    getAllStates = () => {
        try {
            ApiServices.getUserState("")
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    //this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allStatesData: data.map(({ state_id: value, state_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    //this.setState({ isLoading: false });
                });
        } catch (error) {
            //this.setState({ isLoading: false });
        }

        // SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_STATE, SYNC_SERVICE.MASTER_TABLE).then(data => {
        //     if (data && data !== undefined && data.length > 0) {
        //         this.setState({
        //             allStatesData: data.map(({ state_id: value, state_name: label, ...rest }) => ({ value, label, ...rest }))
        //         });
        //     }
        // });
    }

    getAllDistricts = (selectedState) => {
        let request = JSON.stringify({
            state_id: selectedState.value
        })

        try {
            ApiServices.getAllActiveDistrict(request)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    //this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allDistrictsData: data.map(({ district_id: value, district_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    //this.setState({ isLoading: false });
                });
        } catch (error) {
            //this.setState({ isLoading: false });
        }

        // SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_DISTRICT, SYNC_SERVICE.MASTER_TABLE).then(data => {
        //     if (data && data !== undefined && data.length > 0) {
        //         var filterData = [];
        //         for (var i = 0; i < data.length; i++) {
        //             if (data[i].state_id === selectedState.value) {
        //                 filterData.push(data[i]);
        //             }
        //         }
        //         this.setState({
        //             allDistrictsData: filterData.map(({ district_id: value, district_name: label, ...rest }) => ({ value, label, ...rest }))
        //         });
        //     }
        // });
    }

    getAllTehsils = (selectedDistrict) => {
        let request = JSON.stringify({
            district_id: selectedDistrict.value
        })
        try {
            ApiServices.getActiveTehsilByDistrictId(request)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    //this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allTehsilsData: data.map(({ tehsil_id: value, tehsil_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    //this.setState({ isLoading: false });
                });
        } catch (error) {
            //this.setState({ isLoading: false });
        }

        // SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_TEHSIL, SYNC_SERVICE.MASTER_TABLE).then(data => {
        //     if (data && data !== undefined && data.length > 0) {
        //         var filterData = [];
        //         for (var i = 0; i < data.length; i++) {
        //             if (data[i].district_id === selectedDistrict.value) {
        //                 filterData.push(data[i]);
        //             }
        //         }
        //         this.setState({
        //             allTehsilsData: filterData.map(({ tehsil_id: value, tehsil_name: label, ...rest }) => ({ value, label, ...rest }))
        //         });
        //     }
        // });
    }

    getAllVillageById = (selectedTehsil) => {
        let request = JSON.stringify({
            tehsil_id: selectedTehsil.value
        })
        try {
            ApiServices.getAllVillageByUser(request)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    //this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allVillagesData: data.map(({ village_id: value, village_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    //this.setState({ isLoading: false });
                });
        } catch (error) {
            //this.setState({ isLoading: false });
        }

        // SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_VILLAGE, SYNC_SERVICE.MASTER_TABLE).then(data => {
        //     if (data && data !== undefined && data.length > 0) {
        //         var filterData = [];
        //         for (var i = 0; i < data.length; i++) {
        //             if (data[i].tehsil_id === selectedTehsil.value) {
        //                 filterData.push(data[i]);
        //             }
        //         }
        //         this.setState({
        //             allVillagesData: filterData.map(({ village_id: value, village_name: label, ...rest }) => ({ value, label, ...rest }))
        //         });
        //     }
        // });
    }

    onSelectInputChange = () => {
        this.updateNextButton()
    }

    onSelectFocus = () => {
        this.updateNextButton()
    }

    onSelectBlur = () => {
        this.updateNextButton()
    }

    handleOnMenuClose = () => {
        this.updateNextButton()
    }

    handleStateChange = selectedState => {
        if (selectedState === null) {
            this.setState({
                selectedState: null,
                selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null,
            });
        } else {
            this.setState({
                selectedState, selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null
            });
            this.getAllDistricts(selectedState);
        }
        this.setState({ allDistrictsData: [], allTehsilsData: [], allVillagesData: [] });
        this.updateNextButton()
    };

    handleDistrictChange = selectedDistrict => {
        if (selectedDistrict === null) {
            this.setState({
                selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null,
            });
        } else {
            this.setState({
                selectedDistrict, selectedTehsil: null,
                selectedVillage: null
            });
            this.getAllTehsils(selectedDistrict);
        }
        this.setState({ allTehsilsData: [], allVillagesData: [] });
        this.updateNextButton()
    };

    handleTehsilChange = selectedTehsil => {
        if (selectedTehsil === null) {
            this.setState({
                selectedTehsil: null,
                selectedVillage: null,
            }, () => {
                this.updateNextButton();
            });
        } else {
            this.setState({ selectedTehsil, selectedVillage: null }, () => {
                this.updateNextButton();
            });
            this.getAllVillageById(selectedTehsil);
        }
        this.setState({ allVillagesData: [] });
    };

    handleVillageChange = selectedVillage => {
        if (selectedVillage === null) {
            this.setState({
                selectedVillage: null,
            }, () => {
                this.updateNextButton();
            });
        } else {
            this.setState({ selectedVillage }, () => {
                this.updateNextButton();
            });
        }
    };

    handleRoleChange = selectedRole => {

        this.setState({ selectedRole }, () => {
            this.updateNextButton();
        });
    };

    handleEmployeeNameChange = selectedEmployeeName => {

        this.setState({ selectedEmployeeName }, () => {
            this.updateNextButton();
        });

        Utilities.LogPrint(`selectedEmployeeName:`, selectedEmployeeName);

    };

    updateNextButton() {
        const { selectedEmployeeName, selectedRole, selectedState, selectedTehsil, selectedVillage, selectedDistrict } = this.state;
        if (selectedEmployeeName.length !== 0 || selectedRole || selectedState || selectedTehsil || selectedVillage || selectedDistrict) {
            this.getUserLocationReport();
        } else {
            $('#krishakReport').DataTable().clear().draw();
        }
    }

    handleDataPrint = () => {
        // window.print();
        this.setState({ isLoading: true });
        const { selectedEmployeeName, selectedState, selectedTehsil, selectedVillage, selectedDistrict } = this.state;

        let selectedUserIds = [];
        if (selectedEmployeeName && selectedEmployeeName.length !== 0) {
            for (let i = 0; i < selectedEmployeeName.length; i++) {
                selectedUserIds.push(selectedEmployeeName[i].value)
            }
        } else {
            selectedUserIds = []
        }
        Utilities.LogPrint("selectedUserIds", selectedUserIds);

        var body = JSON.stringify({
            state_id: selectedState ? selectedState.value : 0,
            village_id: selectedVillage ? selectedVillage.value : 0,
            district_id: selectedDistrict ? selectedDistrict.value : 0,
            tehsil_id: selectedTehsil ? selectedTehsil.value : 0,
            user_id: selectedUserIds,
        });
        try {
            ApiServices.exportUserLocationReport(body).then(response => {
                this.setState({ isLoading: false });
                Utilities.LogPrint("exportKrishakReport", response);
                Utilities.downloadBlob(response, "UserLocation.xls");
            }).catch(error => {
                this.setState({ isLoading: false });
                Utilities.LogPrint("exportKrishakReport", error);
            });
        } catch (error) {
            this.setState({ isLoading: false });
            Utilities.LogPrint("exportKrishakReport", error);
        }
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isSyncLoading, tableName } = this.state;
        const { isLoading, allEmployeeNameData, selectedEmployeeName, allRoleData, allStatesData, allDistrictsData, allTehsilsData, allVillagesData, selectedState, selectedRole, selectedDistrict, selectedTehsil, selectedVillage } = this.state;

        return (
            <div>
                <Header selectedTab={HeaderTypes.REPORTS} handleSyncLoading={this.handleSyncLoading} />
                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-md-6">
                            <h1>{REPORTS_SCREEN.USER_LOCATION_REPORT}</h1>
                        </div>
                        <div className="col-lg-6 d-md-flex back-btn d-none">
                            <button className="btn btn-secondary" onClick={this.handleDataPrint}><i className="customic print" />{COMMON.DOWNLOAD}</button>

                        </div>
                    </div>
                    {/* <form> */}
                    <form action="">

                        <div className="row mt-4">
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedState}
                                        onChange={this.handleStateChange}
                                        options={allStatesData}
                                        placeholder={COMMON.STATE}
                                        isClearable={true}
                                    // onInputChange={this.onSelectInputChange}
                                    // onFocus={this.onSelectFocus}
                                    // onBlur={this.onSelectBlur}
                                    // onMenuClose={this.handleOnMenuClose}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedDistrict}
                                        onChange={this.handleDistrictChange}
                                        options={allDistrictsData}
                                        placeholder={COMMON.DISTRICT}
                                        isClearable={true}
                                    // onInputChange={this.onSelectInputChange}
                                    // onFocus={this.onSelectFocus}
                                    // onBlur={this.onSelectBlur}
                                    // onMenuClose={this.handleOnMenuClose}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedTehsil}
                                        onChange={this.handleTehsilChange}
                                        options={allTehsilsData}
                                        placeholder={COMMON.TEHSIL}
                                        isClearable={true}
                                    // onInputChange={this.onSelectInputChange}
                                    // onFocus={this.onSelectFocus}
                                    // onBlur={this.onSelectBlur}
                                    // onMenuClose={this.handleOnMenuClose}
                                    />

                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedVillage}
                                        onChange={this.handleVillageChange}
                                        options={allVillagesData}
                                        placeholder={COMMON.VILLAGE}
                                        isClearable={true}
                                    // onInputChange={this.onSelectInputChange}
                                    // onFocus={this.onSelectFocus}
                                    // onBlur={this.onSelectBlur}
                                    // onMenuClose={this.handleOnMenuClose}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"

                                        value={selectedRole}
                                        onChange={this.handleRoleChange}
                                        options={allRoleData}
                                        placeholder={COMMON.ROLE}
                                        isClearable={true}
                                    />
                                </div>
                            </div>

                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedEmployeeName}
                                        onChange={this.handleEmployeeNameChange}
                                        options={allEmployeeNameData}
                                        placeholder={COMMON.EMPLOYEE_NAME}
                                        isClearable={true}
                                        isMulti
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                    <table id="krishakReport" ref={(el) => (this.el = el)} className="display table table-responsive table-striped table-bordered mobile-number">

                    </table>
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                {isLoading ? <Loader /> : null}
                <DesktopFooter />
            </div>
        )
    }
}

export default withRouter(UserLocationReport)